import React from 'react';
import { createPortal } from 'react-dom';
import ChatConfirmCard from './ChatConfirmCard';

/**
 * Where the Allow / Deny card is drawn while a browser-run chat turn waits on
 * it: its own layer on the page, above the panels and dialogs an action may
 * have just opened, whether or not the chat popup is open. Drawn inside the
 * popup it was covered by the very panel `show` opened for the action (the
 * object panels stack at 10001, the popup at 1002) and the turn waited on a
 * card nobody could see. ChatProvider renders it.
 */
const ChatConfirmLayer = ({ pending, onAnswer }) => {
  if (!pending) return null;
  return createPortal(
    <div className="chat-confirm-layer">
      <ChatConfirmCard
        call={pending.call}
        description={pending.description}
        onAllow={() => onAnswer(true)}
        onDeny={() => onAnswer(false)}
      />
    </div>,
    document.body
  );
};

export default ChatConfirmLayer;
